routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
    .state('home.loadCart', {
      url: "load-cart/:id",
      template: `<load-cart sh-ctrl="shCtrl"></load-cart>`,
      data: { 
          id: null
      }
    });
}

export default routesConfig;


/** WEBPACK FOOTER **
 ** ./www/components/load-cart/load-cart.config.js
 **/